export default {
    name: 'QTable',
    props: {
        tableData: { type: Array, default: [] },
        columns: Array,
        title: String,
        filterKey: String,
        actions: { type: Array, default: [] },
        hasCheckboxes: {
            type: Boolean,
            default: false
        },
        hasTitle: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            sortKey: '',
            sortOrders: {},
            currentPage: 0,
            pageSize: 20,
            minPageSize: 20,
            checkedItems: [],
            selectAll: false,
            filteredData: []
        };
    },
    created() {
        this.columns.forEach(key => {
            this.sortOrders[key.name] = 1;
        });
        this.filterData();
    },
    computed: {
        pagedItems: function() {
            if (this.filteredData.length) {
                return this.filteredData.slice(
                    this.currentPage * this.pageSize,
                    this.currentPage * this.pageSize + this.pageSize
                );
            }
        }
    },
    filters: {
        capitalize: function(str) {
            if (!str) {
                return;
            }
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    },
    methods: {
        sortBy: function(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.filterData();
        },
        actionClick: function(item, action) {
            this.$emit('action-click', item, action);
        },
        getItem(item, key) {
            if (key.name.includes('.')) {
                return item[key.name.split('.')[0]][key.name.split('.')[1]];
            } else {
                return item[key.name];
            }
        },
        filterData() {
            let sortKey = this.sortKey;
            let filterKey = this.filterKey && this.filterKey.toLowerCase();
            let order = this.sortOrders[sortKey] || 1;
            let tableData = this.tableData;
            if (filterKey) {
                tableData = tableData.filter(function(row) {
                    return Object.keys(row).some(function(key) {
                        // Searches nested objects from expansions
                        if (typeof row[key] === 'object' && row[key] !== null) {
                            return Object.keys(row[key]).some(expandedKey => {
                                return (
                                    String(row[key][expandedKey])
                                        .toLocaleLowerCase()
                                        .indexOf(filterKey) > -1
                                );
                            });
                        } else {
                            return (
                                String(row[key])
                                    .toLowerCase()
                                    .indexOf(filterKey) > -1
                            );
                        }
                    });
                });
            }
            if (sortKey) {
                tableData = tableData.sort(function(a, b) {
                    if (sortKey.includes('.')) {
                        let key1 = sortKey.split('.')[0];
                        let key2 = sortKey.split('.')[1];
                        a = a[key1][key2];
                        b = b[key1][key2];
                    } else {
                        a = a[sortKey];
                        b = b[sortKey];
                    }
                    if (a === null || a === '') {
                        return 1;
                    }
                    if (b === null || b === '') {
                        return -1;
                    }
                    a = a.toString().toLowerCase();
                    b = b.toString().toLowerCase();
                    return (a === b ? 0 : a > b ? 1 : -1) * order;
                });
            }
            this.filteredData = tableData;
        }
    },
    watch: {
        checkedItems(items) {
            this.$emit('selectItems', items);
        },
        selectAll(checked) {
            // select all items checked -> push item ids to array
            let items = [];
            if (checked) {
                this.pagedItems.forEach(item => {
                    items.push(item.id);
                });
                this.checkedItems = [];
                this.checkedItems = items;
            } else {
                this.checkedItems = [];
            }
            this.$emit('selectItems', this.checkedItems);
            this.$emit('selectAll', checked);
        },
        filterKey: function() {
            this.currentPage = 0;
            this.filterData();
            this.checkedItems = [];
            this.selectAll = false;
        }
    }
};
